import Footer from "../../FrontPage/components/Footer/Footer";
import Header from "../../FrontPage/components/Header/Header";
import NewHeader from "../../FrontPage/LandingPage/HeaderComponent/Header";
import ResetPasswordForm from "../component/ResetPassword/ResetPassword";

const ResetPassword = () => {
  return (
    <div>
      <Header />
      <ResetPasswordForm />
      <Footer />
    </div>
  );
};

export default ResetPassword;
